module.exports = __webpack_public_path__ + "img/hammer.be5030ca.webp";